var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { DatePickerContext } from './DatePickerContext';
export const useDatePickerContext = () => {
    _react_refresh_temp_1();
    const datePickerValue = useContext(DatePickerContext);
    if (!datePickerValue) {
        throw new Error('Date Picker context not provided.');
    }
    return datePickerValue;
};
_react_refresh_temp_1(useDatePickerContext, "dm+SuUuaSBmsFo81kTfaLIhk+po=");
